import { createFileRoute, redirect } from '@tanstack/react-router'

import MonitoringLayout from '@/components/pages/monitoring/_pemetaan-wilker/components/MonitoringLayout'

/** Public route — tanpa autentikasi */
export const Route = createFileRoute('/report')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/report' || location.pathname === '/report/') {
      throw redirect({ to: '/report/pemetaan-wilker/' })
    }
  },
  component: MonitoringLayout
})
